import { Context } from '#store/overmind';
import { logger } from '#utils';

export const loadFavourites = async ({ state, effects }: Context) => {
  try {
    state.favourites.loading = true;
    const response = await effects.favourites.api.getFavourites(
      state.user.profile.id
    );
    state.favourites.items = response;
    state.favourites.loading = false;
  } catch (e) {
    state.favourites.loading = false;
    logger.warn('Problem on loading user favorites', e);
  }
};

export const addFavourite = async (
  { state, effects }: Context,
  iri: string
) => {
  const profileId = state.user.profile.id;
  const item = await effects.favourites.api.addFavourite(profileId, iri);
  if (item) {
    state.favourites.items = [item, ...state.favourites.items];
  }
};

export const removeFavourite = ({ state, effects }: Context, iri: string) => {
  const itemToRemove = state.favourites.items.find((item) => item.iri === iri);

  state.favourites.items = state.favourites.items.filter(
    (item) => item.iri !== iri
  );

  const profileId = state.user.profile.id;
  effects.favourites.api.removeFavourite(profileId, itemToRemove.id);
};
